const flagAircraft = (color) => {
    return `data:image/svg+xml;utf-8, \
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.98 33.06" height="50px" width="50px"><defs><style>.d{fill:${color};}</style></defs><g id="a"/><g id="b"><g id="c"><path class="d" d="M26.98,13.49c0,7.45-13.49,19.57-13.49,19.57,0,0-13.49-12.12-13.49-19.57S6.04,0,13.49,0s13.49,6.04,13.49,13.49Z"/></g></g></svg>`
}

export default flagAircraft

